import { NgModule } from '@angular/core'
import { VOutlet } from './integration/v-outlet'

@NgModule({
  declarations: [ VOutlet ],
  exports: [ VOutlet ],
})
export class VDomModule { }
